module.exports = __webpack_public_path__ + "img/1572473733.e8fe6da8.jpg";